import { AgreementKindEnum } from '../agreement';
import type { SearchParameters } from '../searchParameters';
import { isCreativeOnly, isFilm } from '../searchParameters';

// Whether an agreement can filter the search currently being run.
//
// This is a fact about the *search*, and it is deliberately separate from an
// agreement's `exhausted` flag, which is a fact about the *user*. The BFF
// cannot answer this without being told the current search, so keeping it here
// is what lets the agreements resource stay user-scoped.
//
// Only the editorial subscription is search-dependent: it covers editorial
// stills, so a creative-only search or a film search has nothing for it to
// filter. Every other kind applies wherever it is held.
export const isAgreementApplicable = (
  agreement: { readonly kind: AgreementKindEnum },
  searchParameters: SearchParameters
): boolean => {
  if (agreement.kind !== AgreementKindEnum.ED) return true;

  return !isCreativeOnly(searchParameters) && !isFilm(searchParameters);
};
